import { render } from "./OfferingDocuments.vue?vue&type=template&id=373b3904"
import script from "./OfferingDocuments.vue?vue&type=script&lang=js"
export * from "./OfferingDocuments.vue?vue&type=script&lang=js"
script.render = render

export default script